import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import lodashIsEmpty from 'lodash/isEmpty';
import get from 'lodash/get';

var isEmptyValue = function isEmptyValue(value) {
  return typeof value === 'number' || value === true ? false : lodashIsEmpty(value);
};

var fieldCondition = function fieldCondition(value, config) {
  if (config.isNotEmpty) {
    return !isEmptyValue(value);
  }

  if (config.isEmpty) {
    return isEmptyValue(value);
  }

  if (config.pattern) {
    var regExpPattern = RegExp(config.pattern, config.flags);
    return config.notMatch ? !regExpPattern.test(value) : regExpPattern.test(value);
  }

  if (typeof config.is === 'function') {
    return config.is(value, config);
  }

  if (Object.prototype.hasOwnProperty.call(config, 'greaterThan')) {
    return value > config.greaterThan;
  }

  if (Object.prototype.hasOwnProperty.call(config, 'greaterThanOrEqualTo')) {
    return value >= config.greaterThanOrEqualTo;
  }

  if (Object.prototype.hasOwnProperty.call(config, 'lessThan')) {
    return value < config.lessThan;
  }

  if (Object.prototype.hasOwnProperty.call(config, 'lessThanOrEqualTo')) {
    return value <= config.lessThanOrEqualTo;
  }

  var isMatched = Array.isArray(config.is) ? !!config.is.includes(value) : value === config.is;
  return config.notMatch ? !isMatched : isMatched;
};

export var parseCondition = function parseCondition(condition, values, field) {
  var positiveResult = _objectSpread(_objectSpread({
    visible: true
  }, condition.then), {}, {
    result: true
  });

  var negativeResult = _objectSpread(_objectSpread({
    visible: false
  }, condition["else"]), {}, {
    result: false
  });

  if (Array.isArray(condition)) {
    return !condition.map(function (condition) {
      return parseCondition(condition, values, field);
    }).some(function (_ref) {
      var result = _ref.result;
      return result === false;
    }) ? positiveResult : negativeResult;
  }

  if (condition.and) {
    return !condition.and.map(function (condition) {
      return parseCondition(condition, values, field);
    }).some(function (_ref2) {
      var result = _ref2.result;
      return result === false;
    }) ? positiveResult : negativeResult;
  }

  if (condition.sequence) {
    return condition.sequence.reduce(function (acc, curr) {
      var result = parseCondition(curr, values);
      return {
        sets: [].concat(_toConsumableArray(acc.sets), _toConsumableArray(result.set ? [result.set] : [])),
        visible: acc.visible || result.visible,
        result: acc.result || result.result
      };
    }, _objectSpread(_objectSpread({}, negativeResult), {}, {
      sets: []
    }));
  }

  if (condition.or) {
    return condition.or.map(function (condition) {
      return parseCondition(condition, values, field);
    }).some(function (_ref3) {
      var result = _ref3.result;
      return result === true;
    }) ? positiveResult : negativeResult;
  }

  if (condition.not) {
    return !parseCondition(condition.not, values).result ? positiveResult : negativeResult;
  }

  var finalWhen = typeof condition.when === 'function' ? condition.when(field) : condition.when;

  if (typeof finalWhen === 'string') {
    return fieldCondition(get(values, finalWhen), condition) ? positiveResult : negativeResult;
  }

  if (Array.isArray(finalWhen)) {
    return finalWhen.map(function (fieldName) {
      return fieldCondition(get(values, typeof fieldName === 'function' ? fieldName(field) : fieldName), condition);
    }).find(function (condition) {
      return !!condition;
    }) ? positiveResult : negativeResult;
  }

  return negativeResult;
};
export default parseCondition;